import { Form, Modal, useToaster } from '@innovationdepartment/proxima-ui';
import { useProximaSDK, useShowSpinner } from 'hooks';
import { useState } from 'react';
import { useBrandStore } from 'stores';
import { validateEmail, validateRequired } from 'utils';
import InviteUserModalView from './InviteUserModal.View';

interface IInviteUserModalProps {
  open: boolean;
  onClose: (email?: string) => void;
}

const InviteUserModal = (props: IInviteUserModalProps) => {
  const brandsApi = useProximaSDK('BrandsApi');

  const { open, onClose } = props;
  const { showToaster } = useToaster();
  const [loading, setLoading] = useState(open);

  useShowSpinner({ show: loading });

  const { brand } = useBrandStore();
  const initialValues = { email: '' };

  const { name: brandName } = brand;

  const [submitDisabled, setSubmitDisabled] = useState(false);
  const handleSubmit = async ({ email }: typeof initialValues) => {
    setLoading(true);
    setSubmitDisabled(true);
    let response: Awaited<ReturnType<typeof brandsApi.updateAccess>>;
    try {
      response = await brandsApi.updateAccess({
        brandId: brand.brandId,
        updateAccessRequest: { email: email.trim(), roleId: 'admin' }
      });
    } catch {
      setSubmitDisabled(false);
      setLoading(false);
      return;
    }

    setSubmitDisabled(false);
    setLoading(false);

    if (response.status === 204) {
      onClose(email);
      showToaster({
        message: (
          <>
            Invited&nbsp;<strong>{email}</strong>.
          </>
        ),
        variant: 'success'
      });
    }
  };

  const validate = (formValues: typeof initialValues) => {
    const errors: { [key: string]: string } = {};

    const email = formValues.email?.trim() ?? '';
    if (validateRequired(email)) errors.email = 'Email is required';
    else if (validateEmail(email)) errors.email = 'Email is invalid';

    return errors;
  };

  return (
    <Modal
      resizable
      noPadding={false}
      open={open}
      title={`Invite user to ${brandName}`}
      onClose={onClose}
      allowCloseOnClickOutside
    >
      <Form onSubmit={handleSubmit} initialValues={initialValues} validate={validate}>
        <InviteUserModalView disabled={submitDisabled} onClose={onClose} />
      </Form>
    </Modal>
  );
};

export default InviteUserModal;
